import { RiSearch2Line } from "react-icons/ri";
import '../style/azmoon-list/AL_Search.css';


const AL_Search=()=>{

  const change_color=()=>{
    document.querySelector(".al_search").style.borderColor="#2E81E8";
    document.querySelector(".al_search_icon").style.color="#2E81E8";
  }

  const back_to_default=()=>{
    document.querySelector(".al_search").style.borderColor="#A2B4CB";
    document.querySelector(".al_search_icon").style.color="#A2B4CB";
  }

  return(
    <div className="al_search">
      <RiSearch2Line className="al_search_icon"/>
      <input type="search" name="als_input" id="als_input" className="al_search_input" placeholder="نام آزمون خود را تایپ کنید :)"  onFocus={change_color} onBlur={back_to_default}/>
    </div>
  )
}

export default AL_Search;